
import { FirearmAssignmentMetadataBase } from './firearm-assignment.metadata.base';


export class FirearmAssignmentMetadata extends FirearmAssignmentMetadataBase {
  constructor() {
    super();
  }
}

export const FIREARM_ASSIGNMENT_METADATA: FirearmAssignmentMetadata = new FirearmAssignmentMetadata();


